import React, { useEffect } from 'react';
import { AdvertisingBannerDto, AdvertisingBannerImageTarget, AdvertisingBannerPosition } from '../../types/pages/advertising-banners';
import { Stack } from '@mui/material';
import axiosServices from '../../utils/api/axiosServices';
import { ApiResponse } from '../../types/api';

export const AdvertisingDesktopImageDimensions = {
  width: '970px',
  height: '90px'
};

export const AdvertisingMobileImageDimensions = {
  width: '320px',
  height: '100px'
};

export interface AdBannerProps {
  pageIdentifier: string;
  target: AdvertisingBannerImageTarget;
  position: AdvertisingBannerPosition;
}

const getAdBanner = async (pageIdentifier: string, target: string, position: string) => {
  const url = `advertising/${pageIdentifier}/target/${target}/position/${position}/banner`;
  const response = await axiosServices.get<ApiResponse<AdvertisingBannerDto[]>>(url);
  return response.data.data;
};

const AdBannerInner: React.FC<AdBannerProps> = (props: AdBannerProps) => {
  const [banners, setBanners] = React.useState<AdvertisingBannerDto[]>([]);

  const imageWidth =
    props.target === AdvertisingBannerImageTarget.Desktop
      ? AdvertisingDesktopImageDimensions.width
      : AdvertisingMobileImageDimensions.width;
  const imageHeight =
    props.target === AdvertisingBannerImageTarget.Desktop
      ? AdvertisingDesktopImageDimensions.height
      : AdvertisingMobileImageDimensions.height;

  useEffect(() => {
    if (!props.pageIdentifier) return;

    getAdBanner(
      props.pageIdentifier,
      props.target === AdvertisingBannerImageTarget.Desktop ? 'Desktop' : 'Mobile',
      props.position === AdvertisingBannerPosition.Top ? 'Top' : 'Bottom'
    ).then((r) => {
      if (!!r) {
        setBanners(r);
      }
    });

    return () => setBanners([]);
  }, [props.pageIdentifier, props.target, props.position]);

  if (!props.pageIdentifier) return <></>;

  return (
    <>
      {banners.map((banner, index) => (
        <Stack
          key={index}
          mb={props.position === AdvertisingBannerPosition.Top ? 2 : 0}
          mt={props.position === AdvertisingBannerPosition.Bottom ? 2 : 0}
          justifyContent="center"
          alignItems="center"
        >
          {banner.linkUrl ? (
            <a href={banner.linkUrl} target="_blank" rel="noopener noreferrer">
              <img
                src={banner.imageUrl}
                style={{
                  display: 'block',
                  objectFit: 'contain',
                  width: '100%',
                  height: '100%',
                  maxWidth: imageWidth,
                  maxHeight: imageHeight,
                  cursor: 'pointer'
                }}
                alt={'Ad Banner'}
              />
            </a>
          ) : (
            <img
              src={banner.imageUrl}
              style={{
                display: 'block',
                objectFit: 'contain',
                width: '100%',
                height: '100%',
                maxWidth: imageWidth,
                maxHeight: imageHeight
              }}
              alt={'Ad Banner'}
            />
          )}
        </Stack>
      ))}
    </>
  );
};

export const AdBanner = React.memo(AdBannerInner);
